import { css } from '@emotion/react';
import { fontWeights } from '../theme/type';
import { colors } from '../theme/colors';
import { rem } from '../utilities/style';

// This warning is because emotion adds a style tag as first element in SSR making some
// child selectors invalid. We can ignore this warning because we don't use React to render
// the nodes that these global classes affect. They are rendered by the HubSpot embed.
// https://github.com/emotion-js/emotion/pull/1209
const ignoreSsrFlag = '/* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */';

export default css`
  .hubspot-styles.hbspt-form {
    padding: 0 10px;
  }


  .hubspot-styles .hs-button {
    border: none;
    position: relative;
    text-align: center;
    z-index: 0;
    display: inline-flex;
    align-items: center;
    padding: ${rem(16)} ${rem(25)};
    border-radius: ${rem(40)};
    font-weight: ${fontWeights.bold};
    font-size: 1rem;
    line-height: 1.2;
    background: ${colors.blue['500']};
    color: ${colors.gray['50']};
    overflow: hidden;
    cursor: pointer;
    transition: background-color 0.2s ease;
  }

  .hubspot-styles .hs-button:hover,
  .hubspot-styles .hs-button:focus,
  .hubspot-styles .hs-button:active {
    background: ${colors.blue['800']};
  }

  .hubspot-styles label {
    font-size: 14px;
    width: 130px;
    color: ${colors.blue['800']};
    display: block;
    float: none;
    width: auto;
    font-weight: 600;
    line-height: 20px;
    padding-top: 0;
    margin-bottom: 4px;
  }

  .hubspot-styles .hs-video-form label {
    color: #fff !important;
  }

  .hubspot-styles .hs-video-form .hs-back-button {
    background-color: #fff;
    width: 20%;
    height: 38px;
    margin-right: 10px;
    border: 1px solid;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    -ms-border-radius: 3px;
    border-radius: 3px;
  }

  .hubspot-styles .hs-video-form .hs-button {
    width: 70%;
  }

  .hubspot-styles .hs-video-form .hs-button span {
    font-size: 15px;
  }

  .hubspot-styles .hs-video-form .hs-richtext {
    color: #fff !important;
  }

  .hubspot-styles .hs-video-form .legal-consent-container {
    max-height: 180px !important;
    overflow-y: scroll !important;
  }

  .hubspot-styles .hs-video-form .legal-consent-container:after {
    content: "";
    display: block;
    height: 100px;
    width: 100%;
  }

  .hubspot-styles .hs-video-form .legal-consent-wrapper {
    position: relative;
  }

  .hubspot-styles .hs-video-form .legal-consent-overlay {
    position: absolute;
    pointer-events: none;
    left: 0;
    bottom: 0;
    height: 100px;
    width: 100%;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, #292929 100%);
  }

  .hubspot-styles .hs-error-msgs label {
    color: #e90000;
  }

  .hubspot-styles .hs-input {
    display: inline-block;
    width: 100%;
    max-width: initial;
    height: 34px;
    padding: 9px 10px;
    font-size: 14px;
    font-weight: normal;
    line-height: 22px;
    color: ${colors.gray['600']};
    border: 1px solid #ccc;
    box-sizing: border-box;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    -ms-border-radius: 3px;
    border-radius: 3px;
  }

  .hubspot-styles .hs-input:not([type=file]) {
    background-color: #ffffff;
  }

  .hubspot-styles .hs-input[type=checkbox],
  .hubspot-styles .hs-input[type=radio] {
    cursor: pointer;
    width: auto;
    height: auto;
    padding: 0;
    margin: 3px 5px 3px 0px;
    line-height: normal;
    border: none;
  }

  .hubspot-styles .hs-input[type=file] {
    padding: initial;
    border: initial;
    line-height: initial;
    box-shadow: none;
  }

  .hubspot-styles select {
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
  }

  .hubspot-styles select.hs-input {
    padding: 0 10px;
  }

  .hubspot-styles .hs-fieldtype-select div.input {
    position: relative;
  }

  .hubspot-styles .hs-fieldtype-select div.input::after {
    display:block;
    height:14px;
    width:14px;
    top: 10px;
    background-size: 14px 14px;
    background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNjM1MTg3OTg5MzAyIiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjI4MDAiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCI+PGRlZnM+PC9kZWZzPjxwYXRoIGQ9Ik04MTkuMDc3MTIgNDc4LjY5OTUybC0yMjUuNDg0OCAxOTEuNDg4YTgxLjczNTY4IDgxLjczNTY4IDAgMCAxLTUzLjA0MzIgMTkuNDc2NDggODEuNzc2NjQgODEuNzc2NjQgMCAwIDEtNTMuMDIyNzItMTkuNDc2NDhsLTIyNS40ODQ4LTE5MS40ODhhODEuOTIgODEuOTIgMCAxIDEgMTA2LjA2NTkyLTEyNC44NjY1NmwxNzIuNDQxNiAxNDYuNDUyNDggMTcyLjQ2MjA4LTE0Ni40NTI0OGE4MS45MiA4MS45MiAwIDAgMSAxMDYuMDY1OTIgMTI0Ljg2NjU2eiIgcC1pZD0iMjgwMSI+PC9wYXRoPjwvc3ZnPg==);
    background-repeat: no-repeat;
    position: absolute;
    left: calc(100% - 20px);
    pointer-events: none;
    content: "";
  }

  .hubspot-styles.hbspt-form fieldset.form-columns-1 div.input::after {
    left: calc(100% - 20px);
  }

  @media screen and (max-width: 400px), (min-device-width: 320px) and (max-device-width: 480px) {
    .hubspot-styles .hs-fieldtype-select div.input::after {
      left: calc(100% - 20px);
    }
    .hubspot-styles form.hs-form:not(.hs-video-form) .form-columns-2 .hs-form-field .hs-input {
      width: 100%;
    }
  }

  .hubspot-styles .hs-fieldtype-select div.input:focus::after {
    color: rgba(82, 168, 236, 0.8);
  }

  .hubspot-styles select.is-placeholder {
    color: #bfbfbf;
  }

  .hubspot-styles select.is-placeholder:focus {
    color: #33475b;
  }

  .hubspot-styles .hs-input:-moz-placeholder {
    color: #bfbfbf;
  }

  .hubspot-styles .hs-input::-webkit-input-placeholder {
    color: #bfbfbf;
  }

  .hubspot-styles .hs-input option:disabled {
    color: #bfbfbf;
  }

  .hubspot-styles .hs-input input,
  .hubspot-styles .hs-input textarea {
    transition: border .2s linear;
  }

  .hubspot-styles .hs-input:focus {
    border-color: rgba(82, 168, 236, 0.8);
  }

  .hubspot-styles textarea.hs-input {
    height: auto;
  }

  .hubspot-styles select[multiple].hs-input {
    height: inherit;
  }

  .hubspot-styles input.hs-input.error,
  .hubspot-styles div.field.error input,
  .hubspot-styles div.field.error textarea,
  .hubspot-styles div.field.error .chzn-choices,
  .hubspot-styles textarea.hs-input.error,
  .hubspot-styles select.hs-input.error {
    border-color: #c87872;
  }

  .hubspot-styles input.hs-input.error:focus,
  .hubspot-styles div.field.error input:focus,
  .hubspot-styles div.field.error textarea:focus,
  .hubspot-styles div.field.error .chzn-choices:focus,
  .hubspot-styles textarea.hs-input.error:focus,
  .hubspot-styles select.hs-input.error:focus {
    border-color: #b9554d;
  }

  .hubspot-styles .actions {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .hubspot-styles .inputs-list {
    margin: 0 0 5px;
    width: 100%;
    padding-left: 5px;
  }

  .hubspot-styles .inputs-list > li {
    display: block;
    padding: 0;
    width: 100%;
    padding-top: 0;
    margin: 0;
  }

  .hubspot-styles .inputs-list label {
    float: none;
    width: auto;
    padding: 0;
    line-height: 18px;
    white-space: normal;
    font-weight: normal;
  }

  .hubspot-styles .inputs-list {
    &:first-child ${ignoreSsrFlag} {
      padding-top: 0px;
    }
  }

  .hubspot-styles .inputs-list > li + li {
    padding-top: 2px;
  }

  .hubspot-styles ul.no-list {
    list-style: none;
  }

  .hubspot-styles .field {
    margin-bottom: 18px;
  }

  .hubspot-styles .hs-field-desc {
    color: #7c98b6;
    margin: 0px 0px 6px;
    font-size: 14px;
  }

  .hubspot-styles .hs-form-required {
    color: #e90000;
    margin-left: 3px;
  }

  .hubspot-styles .hs-richtext {
    margin-bottom: 3px;
    line-height: 24px;
    font-size: 14px;
    color: #333333;
  }

  .hubspot-styles .hs-richtext hr {
    margin-left: 0;
    width: 91%;
  }

  .hubspot-styles .hs-custom-style .hs-dependent-field > div input.hs-input:not([type=checkbox]):not([type=radio]) {
    width: 100%;
  }

  .hubspot-styles form.hs-form-rtl .field {
    flex: 0 1 100%;
  }

  .hubspot-styles form.hs-form-rtl .hs-input[type=checkbox],
  .hubspot-styles form.hs-form-rtl .hs-input[type=radio] {
    margin: 3px 5px 3px 5px;
  }

  .hubspot-styles form.hs-form-rtl fieldset {
    display: flex;
  }

  .hubspot-styles form.hs-form-rtl fieldset[class^=form-columns-] .input {
    margin-right: 0px;
  }

  .hubspot-styles form.hs-form-rtl ul {
    padding: 0px;
  }

  .hubspot-styles form.hs-form-rtl .legal-consent-container .hs-form-booleancheckbox-display {
    display: flex;
  }

  .hubspot-styles form.hs-form-rtl .legal-consent-container .hs-form-booleancheckbox-display input {
    width: auto;
    float: none;
  }

  .hubspot-styles form.hs-form-rtl .legal-consent-container .hs-form-booleancheckbox-display > span {
    display: inline-block;
    margin-left: 0px;
  }

  .hubspot-styles form.hs-form-rtl .hs-dependent-field {
    display: flex;
    flex: 0 1 100%;
    flex-wrap: wrap;
  }

  .hubspot-styles .email-correction,
  .hubspot-styles .email-validation {
    padding-top: 3px;
    font-size: 12px;
  }

  .hubspot-styles .email-correction a,
  .hubspot-styles .email-validation a {
    cursor: pointer;
  }

  @media (max-width: 400px), (min-device-width: 320px) and (max-device-width: 480px) {
  .hubspot-styles .email-correction form .form-columns-2 .hs-form-field,
  .hubspot-styles .email-correction form .form-columns-3 .hs-form-field,
  .hubspot-styles .email-validation form .form-columns-2 .hs-form-field,
  .hubspot-styles .email-validation form .form-columns-3 .hs-form-field {
    float: none;
    width: 100%;
  }

  .hubspot-styles .email-correction form .form-columns-2 .hs-form-field .hs-input,
  .hubspot-styles .email-correction form .form-columns-3 .hs-form-field .hs-input,
  .hubspot-styles .email-validation form .form-columns-2 .hs-form-field .hs-input,
  .hubspot-styles .email-validation form .form-columns-3 .hs-form-field .hs-input {
    width: 100%;
  }

  .hubspot-styles .email-correction form .form-columns-2 .hs-form-field input[type=checkbox],
  .hubspot-styles .email-correction form .form-columns-2 .hs-form-field input[type=radio],
  .hubspot-styles .email-correction form .form-columns-3 .hs-form-field input[type=checkbox],
  .hubspot-styles .email-correction form .form-columns-3 .hs-form-field input[type=radio],
  .hubspot-styles .email-validation form .form-columns-2 .hs-form-field input[type=checkbox],
  .hubspot-styles .email-validation form .form-columns-2 .hs-form-field input[type=radio],
  .hubspot-styles .email-validation form .form-columns-3 .hs-form-field input[type=checkbox],
  .hubspot-styles .email-validation form .form-columns-3 .hs-form-field input[type=radio] {
    width: 24px;
  }
  }

  .hubspot-styles .hs-button,
  .hubspot-styles .hs-form-field input[type=text],
  .hubspot-styles .hs-form-field input[type=email],
  .hubspot-styles .hs-form-field input[type=phone],
  .hubspot-styles .hs-form-field input[type=number],
  .hubspot-styles .hs-form-field input[type=tel],
  .hubspot-styles .hs-form-field input[type=date],
  .hubspot-styles .hs-form-field textarea {
  -webkit-appearance: none;
  -moz-appearance: none;
  }

  .hubspot-styles .hs-default-font-element,
  .hubspot-styles .hs-main-font-element {
  }

  .hubspot-styles.hbspt-form.hs-form {
    width: 100%;
  }

  .hubspot-styles.hbspt-form .hs-submit > .actions {
    text-align: left;
  }

  .hubspot-styles.hbspt-form legend.hs-field-desc {
    color: #7C98B6;
    font-size: 11px;
  }

  .hubspot-styles.hbspt-form .hs-form-field label {
    font-size: 14px;
    display: inline-block;
  }

  .hubspot-styles.hbspt-form .hs-form-field label input, .hubspot-styles.hbspt-form .hs-form-field label span {
    vertical-align: middle;
  }

  .hubspot-styles.hbspt-form .hs-form-field label:not(.hs-error-msg) {
    color: #333333;
  }

  .hubspot-styles.hbspt-form .legal-consent-container .hs-richtext,
  .hubspot-styles.hbspt-form .legal-consent-container label {
    color: #333333;
    font-size: 12px;
  }

  .hubspot-styles.hbspt-form .hs-main-font-element,
  .hubspot-styles .submitted-message.hs-main-font-element {
    text-align: center;
  }

  .hubspot-styles.hbspt-form.submitted-message {
    font-size: 16px;
    color: #333333;
  }

  .hubspot-styles .fn-date-picker.pika-single {
    z-index: 9999;
    display: block;
    position: relative;
    color: #333;
    background: #fff;
    border: 1px solid #ccc;
    border-bottom-color: #bbb;
    *zoom: 1;
  }

  .hubspot-styles .fn-date-picker.pika-single.is-hidden {
    display: none;
  }

  .hubspot-styles .fn-date-picker.pika-single.is-bound {
    position: absolute;
    box-shadow: 0 5px 15px -5px rgba(0, 0, 0, 0.5);
  }

  .hubspot-styles .fn-date-picker.pika-single:after,
  .hubspot-styles .fn-date-picker.pika-single:before {
    content: " ";
    display: table;
  }

  .hubspot-styles .fn-date-picker.pika-single:after {
    clear: both;
  }

  .hubspot-styles .fn-date-picker .pika-lendar {
    float: left;
    width: 240px;
    margin: 8px;
  }

  .hubspot-styles .fn-date-picker .pika-title {
    position: relative;
    text-align: center;
  }

  .hubspot-styles .fn-date-picker .pika-title select {
    cursor: pointer;
    position: absolute;
    z-index: 9998;
    margin: 0;
    left: 0;
    top: 5px;
    filter: alpha(opacity=0);
    opacity: 0;
  }

  .hubspot-styles .fn-date-picker .pika-label {
    display: inline-block;
    *display: inline;
    position: relative;
    z-index: 9999;
    overflow: hidden;
    margin: 0;
    padding: 5px 3px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 700;
    background-color: #fff;
  }

  .hubspot-styles .fn-date-picker .pika-next,
  .hubspot-styles .fn-date-picker .pika-prev {
    display: block;
    cursor: pointer;
    position: relative;
    outline: none;
    border: 0;
    padding: 0;
    width: 20px;
    height: 30px;
    text-indent: 20px;
    white-space: nowrap;
    overflow: hidden;
    background-color: transparent;
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: 75% 75%;
    opacity: .5;
    *position: absolute;
    *top: 0;
  }

  .hubspot-styles .fn-date-picker .pika-next:hover,
  .hubspot-styles .fn-date-picker .pika-prev:hover {
    opacity: 1;
  }

  .hubspot-styles .fn-date-picker .pika-next.is-disabled,
  .hubspot-styles .fn-date-picker .pika-prev.is-disabled {
    cursor: default;
    opacity: .2;
  }

  .hubspot-styles .fn-date-picker .is-rtl .pika-next,
  .hubspot-styles .fn-date-picker .pika-prev {
    float: left;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAeCAYAAAAsEj5rAAAAUklEQVR42u3VMQoAIBADQf8Pgj+OD9hG2CtONJB2ymQkKe0HbwAP0xucDiQWARITIDEBEnMgMQ8S8+AqBIl6kKgHiXqQqAeJepBo/z38J/U0uAHlaBkBl9I4GwAAAABJRU5ErkJggg==);
    *left: 0;
  }

  .hubspot-styles .fn-date-picker .is-rtl .pika-prev,
  .hubspot-styles .fn-date-picker .pika-next {
    float: right;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAeCAYAAAAsEj5rAAAAU0lEQVR42u3VOwoAMAgE0dwfAnNjU26bYkBCFGwfiL9VVWoO+BJ4Gf3gtsEKKoFBNTCoCAYVwaAiGNQGMUHMkjGbgjk2mIONuXo0nC8XnCf1JXgArVIZAQh5TKYAAAAASUVORK5CYII=);
    *right: 0;
  }

  .hubspot-styles .fn-date-picker .pika-select {
    display: inline-block;
    *display: inline;
  }

  .hubspot-styles .fn-date-picker .pika-table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    border: 0;
  }

  .hubspot-styles .fn-date-picker .pika-table td,
  .hubspot-styles .fn-date-picker .pika-table th {
    width: 14.285714285714286%;
    padding: 0;
  }

  .hubspot-styles .fn-date-picker .pika-table th {
    color: #999;
    font-size: 12px;
    line-height: 25px;
    font-weight: 700;
    text-align: center;
  }

  .hubspot-styles .fn-date-picker .pika-table abbr {
    border-bottom: none;
    cursor: help;
  }

  .hubspot-styles .fn-date-picker .pika-button {
    cursor: pointer;
    display: block;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    outline: none;
    border: 0;
    margin: 0;
    width: 100%;
    padding: 5px;
    color: #666;
    font-size: 12px;
    line-height: 15px;
    text-align: right;
    background: #f5f5f5;
  }

  .hubspot-styles .fn-date-picker .pika-button:hover {
    color: #fff !important;
    background: #ff8000 !important;
    box-shadow: none !important;
    border-radius: 3px !important;
  }

  .hubspot-styles .fn-date-picker .is-today .pika-button {
    color: #3af;
    font-weight: 700;
  }

  .hubspot-styles .fn-date-picker .is-selected .pika-button {
    color: #fff;
    font-weight: 700;
    background: #3af;
    box-shadow: inset 0 1px 3px #178fe5;
    border-radius: 3px;
  }

  .hubspot-styles .fn-date-picker .is-disabled .pika-button {
    pointer-events: none;
    cursor: default;
    color: #999;
    opacity: .3;
  }

  .hubspot-styles .fn-date-picker .pika-week {
    font-size: 11px;
    color: #999;
  }

  .hubspot-styles.hbspt-form .inputs-list.inline-list li {
    vertical-align: top;
    display: inline-block;
    word-wrap: break-word;
    padding-right: 16px;
  }

  .hubspot-styles.hbspt-form .inputs-list.inline-list li:after {
    clear: both;
  }

  .hubspot-styles.hbspt-form .inputs-list.inline-list li input {
    float: left;
  }

  .hubspot-styles.hbspt-form .inputs-list.inline-list.inline-list-2 li {
    width: 50%;
  }

  .hubspot-styles.hbspt-form .inputs-list.inline-list.inline-list-2 li:nth-of-type(2n) {
    padding-right: 0;
  }

  .hubspot-styles.hbspt-form .inputs-list.inline-list.inline-list-3 li {
    width: 33%;
  }

  .hubspot-styles.hbspt-form .inputs-list.inline-list.inline-list-3 li:nth-of-type(3n) {
    width: 34%;
    padding-right: 0;
  }

  .hubspot-styles .hs-fieldtype-intl-phone.hs-input {
    padding: 0;
    background: none;
    border: none;
    height: auto;
  }

  .hubspot-styles .hs-fieldtype-intl-phone.hs-input:after {
    clear: both;
    content: " ";
    display: table;
  }

  .hubspot-styles .hs-fieldtype-intl-phone.hs-input .hs-input {
    margin-bottom: 0;
  }

  .hubspot-styles .hs-fieldtype-intl-phone.hs-input input {
    width: 68% !important;
    float: right;
  }

  .hubspot-styles .hs-fieldtype-intl-phone.hs-input select {
    float: left;
    width: 30% !important;
  }

  @media (max-device-width: 480px) and (min-device-width: 320px), (max-width: 400px) {
  .hubspot-styles.hbspt-form > .hs-phone > .input > .hs-fieldtype-intl-phone.hs-input > input.hs-input {
    width: 68% !important;
  }

  .hubspot-styles.hbspt-form > .hs-phone > .input > .hs-fieldtype-intl-phone.hs-input > select.hs-input {
    width: 30% !important;
  }
  }

  .hubspot-styles .hs-input-range-container {
    width: 100%;
  }

  .hubspot-styles .hs-input-range-container div {
    display: inline-block;
    line-height: 50px;
  }

  .hubspot-styles .hs-input-range-container .hs-input-range {
    width: 90%;
    height: 40px;
  }

  .hubspot-styles .hs-input-range-container .hs-input-range > * {
    vertical-align: middle;
  }

  .hubspot-styles .hs-input-range-container .hs-input-range input {
    margin: 0 5px;
    width: 85%;
  }

  .hubspot-styles .hs-input-range-container .hs-input-range-value-container {
    width: 10%;
  }

  .hubspot-styles .hs-input-range-container .hs-input {
    width: 100% !important;
    margin-right: 1px;
    background-color: #fff;
    text-align: center;
  }

  .hubspot-styles .hs-input-range__slider {
    appearance: none;
    margin: 0;
    height: 30px;
    overflow: hidden;
    cursor: pointer;
  }

  .hubspot-styles .hs-input-range__slider:focus {
    outline: none;
  }

  .hubspot-styles .hs-input-range__slider::-webkit-slider-runnable-track {
    width: 100%;
    height: 30px;
    background: linear-gradient(180deg, #0199ff, #0199ff) 100% 50%/100% 3px no-repeat transparent;
  }

  .hubspot-styles .hs-input-range__slider::-webkit-slider-thumb {
    position: relative;
    appearance: none;
    height: 13px;
    width: 13px;
    background: #0199ff;
    border-radius: 100%;
    border: 0;
    top: 50%;
    margin-top: -7.5px;
    box-shadow: 1px 0 0 -5px #cfcfcf, 2px 0 0 -5px #cfcfcf, 3px 0 0 -5px #cfcfcf, 4px 0 0 -5px #cfcfcf, 5px 0 0 -5px #cfcfcf, 6px 0 0 -5px #cfcfcf, 7px 0 0 -5px #cfcfcf, 8px 0 0 -5px #cfcfcf, 9px 0 0 -5px #cfcfcf, 10px 0 0 -5px #cfcfcf, 11px 0 0 -5px #cfcfcf, 12px 0 0 -5px #cfcfcf, 13px 0 0 -5px #cfcfcf, 14px 0 0 -5px #cfcfcf, 15px 0 0 -5px #cfcfcf, 16px 0 0 -5px #cfcfcf, 17px 0 0 -5px #cfcfcf, 18px 0 0 -5px #cfcfcf, 19px 0 0 -5px #cfcfcf, 20px 0 0 -5px #cfcfcf, 21px 0 0 -5px #cfcfcf, 22px 0 0 -5px #cfcfcf, 23px 0 0 -5px #cfcfcf, 24px 0 0 -5px #cfcfcf, 25px 0 0 -5px #cfcfcf, 26px 0 0 -5px #cfcfcf, 27px 0 0 -5px #cfcfcf, 28px 0 0 -5px #cfcfcf, 29px 0 0 -5px #cfcfcf, 30px 0 0 -5px #cfcfcf, 31px 0 0 -5px #cfcfcf, 32px 0 0 -5px #cfcfcf, 33px 0 0 -5px #cfcfcf, 34px 0 0 -5px #cfcfcf, 35px 0 0 -5px #cfcfcf, 36px 0 0 -5px #cfcfcf, 37px 0 0 -5px #cfcfcf, 38px 0 0 -5px #cfcfcf, 39px 0 0 -5px #cfcfcf, 40px 0 0 -5px #cfcfcf, 41px 0 0 -5px #cfcfcf, 42px 0 0 -5px #cfcfcf, 43px 0 0 -5px #cfcfcf, 44px 0 0 -5px #cfcfcf, 45px 0 0 -5px #cfcfcf, 46px 0 0 -5px #cfcfcf, 47px 0 0 -5px #cfcfcf, 48px 0 0 -5px #cfcfcf, 49px 0 0 -5px #cfcfcf, 50px 0 0 -5px #cfcfcf, 51px 0 0 -5px #cfcfcf, 52px 0 0 -5px #cfcfcf, 53px 0 0 -5px #cfcfcf, 54px 0 0 -5px #cfcfcf, 55px 0 0 -5px #cfcfcf, 56px 0 0 -5px #cfcfcf, 57px 0 0 -5px #cfcfcf, 58px 0 0 -5px #cfcfcf, 59px 0 0 -5px #cfcfcf, 60px 0 0 -5px #cfcfcf, 61px 0 0 -5px #cfcfcf, 62px 0 0 -5px #cfcfcf, 63px 0 0 -5px #cfcfcf, 64px 0 0 -5px #cfcfcf, 65px 0 0 -5px #cfcfcf, 66px 0 0 -5px #cfcfcf, 67px 0 0 -5px #cfcfcf, 68px 0 0 -5px #cfcfcf, 69px 0 0 -5px #cfcfcf, 70px 0 0 -5px #cfcfcf, 71px 0 0 -5px #cfcfcf, 72px 0 0 -5px #cfcfcf, 73px 0 0 -5px #cfcfcf, 74px 0 0 -5px #cfcfcf, 75px 0 0 -5px #cfcfcf, 76px 0 0 -5px #cfcfcf, 77px 0 0 -5px #cfcfcf, 78px 0 0 -5px #cfcfcf, 79px 0 0 -5px #cfcfcf, 80px 0 0 -5px #cfcfcf, 81px 0 0 -5px #cfcfcf, 82px 0 0 -5px #cfcfcf, 83px 0 0 -5px #cfcfcf, 84px 0 0 -5px #cfcfcf, 85px 0 0 -5px #cfcfcf, 86px 0 0 -5px #cfcfcf, 87px 0 0 -5px #cfcfcf, 88px 0 0 -5px #cfcfcf, 89px 0 0 -5px #cfcfcf, 90px 0 0 -5px #cfcfcf, 91px 0 0 -5px #cfcfcf, 92px 0 0 -5px #cfcfcf, 93px 0 0 -5px #cfcfcf, 94px 0 0 -5px #cfcfcf, 95px 0 0 -5px #cfcfcf, 96px 0 0 -5px #cfcfcf, 97px 0 0 -5px #cfcfcf, 98px 0 0 -5px #cfcfcf, 99px 0 0 -5px #cfcfcf, 100px 0 0 -5px #cfcfcf, 101px 0 0 -5px #cfcfcf, 102px 0 0 -5px #cfcfcf, 103px 0 0 -5px #cfcfcf, 104px 0 0 -5px #cfcfcf, 105px 0 0 -5px #cfcfcf, 106px 0 0 -5px #cfcfcf, 107px 0 0 -5px #cfcfcf, 108px 0 0 -5px #cfcfcf, 109px 0 0 -5px #cfcfcf, 110px 0 0 -5px #cfcfcf, 111px 0 0 -5px #cfcfcf, 112px 0 0 -5px #cfcfcf, 113px 0 0 -5px #cfcfcf, 114px 0 0 -5px #cfcfcf, 115px 0 0 -5px #cfcfcf, 116px 0 0 -5px #cfcfcf, 117px 0 0 -5px #cfcfcf, 118px 0 0 -5px #cfcfcf, 119px 0 0 -5px #cfcfcf, 120px 0 0 -5px #cfcfcf, 121px 0 0 -5px #cfcfcf, 122px 0 0 -5px #cfcfcf, 123px 0 0 -5px #cfcfcf, 124px 0 0 -5px #cfcfcf, 125px 0 0 -5px #cfcfcf, 126px 0 0 -5px #cfcfcf, 127px 0 0 -5px #cfcfcf, 128px 0 0 -5px #cfcfcf, 129px 0 0 -5px #cfcfcf, 130px 0 0 -5px #cfcfcf, 131px 0 0 -5px #cfcfcf, 132px 0 0 -5px #cfcfcf, 133px 0 0 -5px #cfcfcf, 134px 0 0 -5px #cfcfcf, 135px 0 0 -5px #cfcfcf, 136px 0 0 -5px #cfcfcf, 137px 0 0 -5px #cfcfcf, 138px 0 0 -5px #cfcfcf, 139px 0 0 -5px #cfcfcf, 140px 0 0 -5px #cfcfcf, 141px 0 0 -5px #cfcfcf, 142px 0 0 -5px #cfcfcf, 143px 0 0 -5px #cfcfcf, 144px 0 0 -5px #cfcfcf, 145px 0 0 -5px #cfcfcf, 146px 0 0 -5px #cfcfcf, 147px 0 0 -5px #cfcfcf, 148px 0 0 -5px #cfcfcf, 149px 0 0 -5px #cfcfcf, 150px 0 0 -5px #cfcfcf, 151px 0 0 -5px #cfcfcf, 152px 0 0 -5px #cfcfcf, 153px 0 0 -5px #cfcfcf, 154px 0 0 -5px #cfcfcf, 155px 0 0 -5px #cfcfcf, 156px 0 0 -5px #cfcfcf, 157px 0 0 -5px #cfcfcf, 158px 0 0 -5px #cfcfcf, 159px 0 0 -5px #cfcfcf, 160px 0 0 -5px #cfcfcf, 161px 0 0 -5px #cfcfcf, 162px 0 0 -5px #cfcfcf, 163px 0 0 -5px #cfcfcf, 164px 0 0 -5px #cfcfcf, 165px 0 0 -5px #cfcfcf, 166px 0 0 -5px #cfcfcf, 167px 0 0 -5px #cfcfcf, 168px 0 0 -5px #cfcfcf, 169px 0 0 -5px #cfcfcf, 170px 0 0 -5px #cfcfcf, 171px 0 0 -5px #cfcfcf, 172px 0 0 -5px #cfcfcf, 173px 0 0 -5px #cfcfcf, 174px 0 0 -5px #cfcfcf, 175px 0 0 -5px #cfcfcf, 176px 0 0 -5px #cfcfcf, 177px 0 0 -5px #cfcfcf, 178px 0 0 -5px #cfcfcf, 179px 0 0 -5px #cfcfcf, 180px 0 0 -5px #cfcfcf, 181px 0 0 -5px #cfcfcf, 182px 0 0 -5px #cfcfcf, 183px 0 0 -5px #cfcfcf, 184px 0 0 -5px #cfcfcf, 185px 0 0 -5px #cfcfcf, 186px 0 0 -5px #cfcfcf, 187px 0 0 -5px #cfcfcf, 188px 0 0 -5px #cfcfcf, 189px 0 0 -5px #cfcfcf, 190px 0 0 -5px #cfcfcf, 191px 0 0 -5px #cfcfcf, 192px 0 0 -5px #cfcfcf, 193px 0 0 -5px #cfcfcf, 194px 0 0 -5px #cfcfcf, 195px 0 0 -5px #cfcfcf, 196px 0 0 -5px #cfcfcf, 197px 0 0 -5px #cfcfcf, 198px 0 0 -5px #cfcfcf, 199px 0 0 -5px #cfcfcf, 200px 0 0 -5px #cfcfcf, 201px 0 0 -5px #cfcfcf, 202px 0 0 -5px #cfcfcf, 203px 0 0 -5px #cfcfcf, 204px 0 0 -5px #cfcfcf, 205px 0 0 -5px #cfcfcf, 206px 0 0 -5px #cfcfcf, 207px 0 0 -5px #cfcfcf, 208px 0 0 -5px #cfcfcf, 209px 0 0 -5px #cfcfcf, 210px 0 0 -5px #cfcfcf, 211px 0 0 -5px #cfcfcf, 212px 0 0 -5px #cfcfcf, 213px 0 0 -5px #cfcfcf, 214px 0 0 -5px #cfcfcf, 215px 0 0 -5px #cfcfcf, 216px 0 0 -5px #cfcfcf, 217px 0 0 -5px #cfcfcf, 218px 0 0 -5px #cfcfcf, 219px 0 0 -5px #cfcfcf, 220px 0 0 -5px #cfcfcf, 221px 0 0 -5px #cfcfcf, 222px 0 0 -5px #cfcfcf, 223px 0 0 -5px #cfcfcf, 224px 0 0 -5px #cfcfcf, 225px 0 0 -5px #cfcfcf, 226px 0 0 -5px #cfcfcf, 227px 0 0 -5px #cfcfcf, 228px 0 0 -5px #cfcfcf, 229px 0 0 -5px #cfcfcf, 230px 0 0 -5px #cfcfcf, 231px 0 0 -5px #cfcfcf, 232px 0 0 -5px #cfcfcf, 233px 0 0 -5px #cfcfcf, 234px 0 0 -5px #cfcfcf, 235px 0 0 -5px #cfcfcf, 236px 0 0 -5px #cfcfcf, 237px 0 0 -5px #cfcfcf, 238px 0 0 -5px #cfcfcf, 239px 0 0 -5px #cfcfcf, 240px 0 0 -5px #cfcfcf, 241px 0 0 -5px #cfcfcf, 242px 0 0 -5px #cfcfcf, 243px 0 0 -5px #cfcfcf, 244px 0 0 -5px #cfcfcf, 245px 0 0 -5px #cfcfcf, 246px 0 0 -5px #cfcfcf, 247px 0 0 -5px #cfcfcf, 248px 0 0 -5px #cfcfcf, 249px 0 0 -5px #cfcfcf, 250px 0 0 -5px #cfcfcf, 251px 0 0 -5px #cfcfcf, 252px 0 0 -5px #cfcfcf, 253px 0 0 -5px #cfcfcf, 254px 0 0 -5px #cfcfcf, 255px 0 0 -5px #cfcfcf, 256px 0 0 -5px #cfcfcf, 257px 0 0 -5px #cfcfcf, 258px 0 0 -5px #cfcfcf, 259px 0 0 -5px #cfcfcf, 260px 0 0 -5px #cfcfcf, 261px 0 0 -5px #cfcfcf, 262px 0 0 -5px #cfcfcf, 263px 0 0 -5px #cfcfcf, 264px 0 0 -5px #cfcfcf, 265px 0 0 -5px #cfcfcf, 266px 0 0 -5px #cfcfcf, 267px 0 0 -5px #cfcfcf, 268px 0 0 -5px #cfcfcf, 269px 0 0 -5px #cfcfcf, 270px 0 0 -5px #cfcfcf, 271px 0 0 -5px #cfcfcf, 272px 0 0 -5px #cfcfcf, 273px 0 0 -5px #cfcfcf, 274px 0 0 -5px #cfcfcf, 275px 0 0 -5px #cfcfcf, 276px 0 0 -5px #cfcfcf, 277px 0 0 -5px #cfcfcf, 278px 0 0 -5px #cfcfcf, 279px 0 0 -5px #cfcfcf, 280px 0 0 -5px #cfcfcf, 281px 0 0 -5px #cfcfcf, 282px 0 0 -5px #cfcfcf, 283px 0 0 -5px #cfcfcf, 284px 0 0 -5px #cfcfcf, 285px 0 0 -5px #cfcfcf, 286px 0 0 -5px #cfcfcf, 287px 0 0 -5px #cfcfcf, 288px 0 0 -5px #cfcfcf, 289px 0 0 -5px #cfcfcf, 290px 0 0 -5px #cfcfcf, 291px 0 0 -5px #cfcfcf, 292px 0 0 -5px #cfcfcf, 293px 0 0 -5px #cfcfcf, 294px 0 0 -5px #cfcfcf, 295px 0 0 -5px #cfcfcf, 296px 0 0 -5px #cfcfcf, 297px 0 0 -5px #cfcfcf, 298px 0 0 -5px #cfcfcf, 299px 0 0 -5px #cfcfcf, 300px 0 0 -5px #cfcfcf, 301px 0 0 -5px #cfcfcf, 302px 0 0 -5px #cfcfcf, 303px 0 0 -5px #cfcfcf, 304px 0 0 -5px #cfcfcf, 305px 0 0 -5px #cfcfcf, 306px 0 0 -5px #cfcfcf, 307px 0 0 -5px #cfcfcf, 308px 0 0 -5px #cfcfcf, 309px 0 0 -5px #cfcfcf, 310px 0 0 -5px #cfcfcf, 311px 0 0 -5px #cfcfcf, 312px 0 0 -5px #cfcfcf, 313px 0 0 -5px #cfcfcf, 314px 0 0 -5px #cfcfcf, 315px 0 0 -5px #cfcfcf, 316px 0 0 -5px #cfcfcf, 317px 0 0 -5px #cfcfcf, 318px 0 0 -5px #cfcfcf, 319px 0 0 -5px #cfcfcf, 320px 0 0 -5px #cfcfcf, 321px 0 0 -5px #cfcfcf, 322px 0 0 -5px #cfcfcf, 323px 0 0 -5px #cfcfcf, 324px 0 0 -5px #cfcfcf, 325px 0 0 -5px #cfcfcf, 326px 0 0 -5px #cfcfcf, 327px 0 0 -5px #cfcfcf, 328px 0 0 -5px #cfcfcf, 329px 0 0 -5px #cfcfcf, 330px 0 0 -5px #cfcfcf, 331px 0 0 -5px #cfcfcf, 332px 0 0 -5px #cfcfcf, 333px 0 0 -5px #cfcfcf, 334px 0 0 -5px #cfcfcf, 335px 0 0 -5px #cfcfcf, 336px 0 0 -5px #cfcfcf, 337px 0 0 -5px #cfcfcf, 338px 0 0 -5px #cfcfcf, 339px 0 0 -5px #cfcfcf, 340px 0 0 -5px #cfcfcf, 341px 0 0 -5px #cfcfcf, 342px 0 0 -5px #cfcfcf, 343px 0 0 -5px #cfcfcf, 344px 0 0 -5px #cfcfcf, 345px 0 0 -5px #cfcfcf, 346px 0 0 -5px #cfcfcf, 347px 0 0 -5px #cfcfcf, 348px 0 0 -5px #cfcfcf, 349px 0 0 -5px #cfcfcf, 350px 0 0 -5px #cfcfcf, 351px 0 0 -5px #cfcfcf, 352px 0 0 -5px #cfcfcf, 353px 0 0 -5px #cfcfcf, 354px 0 0 -5px #cfcfcf, 355px 0 0 -5px #cfcfcf, 356px 0 0 -5px #cfcfcf, 357px 0 0 -5px #cfcfcf, 358px 0 0 -5px #cfcfcf, 359px 0 0 -5px #cfcfcf, 360px 0 0 -5px #cfcfcf, 361px 0 0 -5px #cfcfcf, 362px 0 0 -5px #cfcfcf, 363px 0 0 -5px #cfcfcf, 364px 0 0 -5px #cfcfcf, 365px 0 0 -5px #cfcfcf, 366px 0 0 -5px #cfcfcf, 367px 0 0 -5px #cfcfcf, 368px 0 0 -5px #cfcfcf, 369px 0 0 -5px #cfcfcf, 370px 0 0 -5px #cfcfcf, 371px 0 0 -5px #cfcfcf, 372px 0 0 -5px #cfcfcf, 373px 0 0 -5px #cfcfcf, 374px 0 0 -5px #cfcfcf, 375px 0 0 -5px #cfcfcf, 376px 0 0 -5px #cfcfcf, 377px 0 0 -5px #cfcfcf, 378px 0 0 -5px #cfcfcf, 379px 0 0 -5px #cfcfcf, 380px 0 0 -5px #cfcfcf, 381px 0 0 -5px #cfcfcf, 382px 0 0 -5px #cfcfcf, 383px 0 0 -5px #cfcfcf, 384px 0 0 -5px #cfcfcf, 385px 0 0 -5px #cfcfcf, 386px 0 0 -5px #cfcfcf, 387px 0 0 -5px #cfcfcf, 388px 0 0 -5px #cfcfcf, 389px 0 0 -5px #cfcfcf, 390px 0 0 -5px #cfcfcf, 391px 0 0 -5px #cfcfcf, 392px 0 0 -5px #cfcfcf, 393px 0 0 -5px #cfcfcf, 394px 0 0 -5px #cfcfcf, 395px 0 0 -5px #cfcfcf, 396px 0 0 -5px #cfcfcf, 397px 0 0 -5px #cfcfcf, 398px 0 0 -5px #cfcfcf, 399px 0 0 -5px #cfcfcf, 400px 0 0 -5px #cfcfcf, 401px 0 0 -5px #cfcfcf, 402px 0 0 -5px #cfcfcf, 403px 0 0 -5px #cfcfcf, 404px 0 0 -5px #cfcfcf, 405px 0 0 -5px #cfcfcf, 406px 0 0 -5px #cfcfcf, 407px 0 0 -5px #cfcfcf, 408px 0 0 -5px #cfcfcf, 409px 0 0 -5px #cfcfcf, 410px 0 0 -5px #cfcfcf, 411px 0 0 -5px #cfcfcf, 412px 0 0 -5px #cfcfcf, 413px 0 0 -5px #cfcfcf, 414px 0 0 -5px #cfcfcf, 415px 0 0 -5px #cfcfcf, 416px 0 0 -5px #cfcfcf, 417px 0 0 -5px #cfcfcf, 418px 0 0 -5px #cfcfcf, 419px 0 0 -5px #cfcfcf, 420px 0 0 -5px #cfcfcf, 421px 0 0 -5px #cfcfcf, 422px 0 0 -5px #cfcfcf, 423px 0 0 -5px #cfcfcf, 424px 0 0 -5px #cfcfcf, 425px 0 0 -5px #cfcfcf, 426px 0 0 -5px #cfcfcf, 427px 0 0 -5px #cfcfcf, 428px 0 0 -5px #cfcfcf, 429px 0 0 -5px #cfcfcf, 430px 0 0 -5px #cfcfcf, 431px 0 0 -5px #cfcfcf, 432px 0 0 -5px #cfcfcf, 433px 0 0 -5px #cfcfcf, 434px 0 0 -5px #cfcfcf, 435px 0 0 -5px #cfcfcf, 436px 0 0 -5px #cfcfcf, 437px 0 0 -5px #cfcfcf, 438px 0 0 -5px #cfcfcf, 439px 0 0 -5px #cfcfcf, 440px 0 0 -5px #cfcfcf, 441px 0 0 -5px #cfcfcf, 442px 0 0 -5px #cfcfcf, 443px 0 0 -5px #cfcfcf, 444px 0 0 -5px #cfcfcf, 445px 0 0 -5px #cfcfcf, 446px 0 0 -5px #cfcfcf, 447px 0 0 -5px #cfcfcf, 448px 0 0 -5px #cfcfcf, 449px 0 0 -5px #cfcfcf, 450px 0 0 -5px #cfcfcf, 451px 0 0 -5px #cfcfcf, 452px 0 0 -5px #cfcfcf, 453px 0 0 -5px #cfcfcf, 454px 0 0 -5px #cfcfcf, 455px 0 0 -5px #cfcfcf, 456px 0 0 -5px #cfcfcf, 457px 0 0 -5px #cfcfcf, 458px 0 0 -5px #cfcfcf, 459px 0 0 -5px #cfcfcf, 460px 0 0 -5px #cfcfcf, 461px 0 0 -5px #cfcfcf, 462px 0 0 -5px #cfcfcf, 463px 0 0 -5px #cfcfcf, 464px 0 0 -5px #cfcfcf, 465px 0 0 -5px #cfcfcf, 466px 0 0 -5px #cfcfcf, 467px 0 0 -5px #cfcfcf, 468px 0 0 -5px #cfcfcf, 469px 0 0 -5px #cfcfcf, 470px 0 0 -5px #cfcfcf, 471px 0 0 -5px #cfcfcf, 472px 0 0 -5px #cfcfcf, 473px 0 0 -5px #cfcfcf, 474px 0 0 -5px #cfcfcf, 475px 0 0 -5px #cfcfcf, 476px 0 0 -5px #cfcfcf, 477px 0 0 -5px #cfcfcf, 478px 0 0 -5px #cfcfcf, 479px 0 0 -5px #cfcfcf, 480px 0 0 -5px #cfcfcf, 481px 0 0 -5px #cfcfcf, 482px 0 0 -5px #cfcfcf, 483px 0 0 -5px #cfcfcf, 484px 0 0 -5px #cfcfcf, 485px 0 0 -5px #cfcfcf, 486px 0 0 -5px #cfcfcf, 487px 0 0 -5px #cfcfcf, 488px 0 0 -5px #cfcfcf, 489px 0 0 -5px #cfcfcf, 490px 0 0 -5px #cfcfcf, 491px 0 0 -5px #cfcfcf, 492px 0 0 -5px #cfcfcf, 493px 0 0 -5px #cfcfcf, 494px 0 0 -5px #cfcfcf, 495px 0 0 -5px #cfcfcf, 496px 0 0 -5px #cfcfcf, 497px 0 0 -5px #cfcfcf, 498px 0 0 -5px #cfcfcf, 499px 0 0 -5px #cfcfcf, 500px 0 0 -5px #cfcfcf, 501px 0 0 -5px #cfcfcf, 502px 0 0 -5px #cfcfcf, 503px 0 0 -5px #cfcfcf, 504px 0 0 -5px #cfcfcf, 505px 0 0 -5px #cfcfcf, 506px 0 0 -5px #cfcfcf, 507px 0 0 -5px #cfcfcf, 508px 0 0 -5px #cfcfcf, 509px 0 0 -5px #cfcfcf, 510px 0 0 -5px #cfcfcf, 511px 0 0 -5px #cfcfcf, 512px 0 0 -5px #cfcfcf, 513px 0 0 -5px #cfcfcf, 514px 0 0 -5px #cfcfcf, 515px 0 0 -5px #cfcfcf, 516px 0 0 -5px #cfcfcf, 517px 0 0 -5px #cfcfcf, 518px 0 0 -5px #cfcfcf, 519px 0 0 -5px #cfcfcf, 520px 0 0 -5px #cfcfcf, 521px 0 0 -5px #cfcfcf, 522px 0 0 -5px #cfcfcf, 523px 0 0 -5px #cfcfcf, 524px 0 0 -5px #cfcfcf, 525px 0 0 -5px #cfcfcf, 526px 0 0 -5px #cfcfcf, 527px 0 0 -5px #cfcfcf, 528px 0 0 -5px #cfcfcf, 529px 0 0 -5px #cfcfcf, 530px 0 0 -5px #cfcfcf, 531px 0 0 -5px #cfcfcf, 532px 0 0 -5px #cfcfcf, 533px 0 0 -5px #cfcfcf, 534px 0 0 -5px #cfcfcf, 535px 0 0 -5px #cfcfcf, 536px 0 0 -5px #cfcfcf, 537px 0 0 -5px #cfcfcf, 538px 0 0 -5px #cfcfcf, 539px 0 0 -5px #cfcfcf, 540px 0 0 -5px #cfcfcf, 541px 0 0 -5px #cfcfcf, 542px 0 0 -5px #cfcfcf, 543px 0 0 -5px #cfcfcf, 544px 0 0 -5px #cfcfcf, 545px 0 0 -5px #cfcfcf, 546px 0 0 -5px #cfcfcf, 547px 0 0 -5px #cfcfcf, 548px 0 0 -5px #cfcfcf, 549px 0 0 -5px #cfcfcf, 550px 0 0 -5px #cfcfcf, 551px 0 0 -5px #cfcfcf, 552px 0 0 -5px #cfcfcf, 553px 0 0 -5px #cfcfcf, 554px 0 0 -5px #cfcfcf, 555px 0 0 -5px #cfcfcf, 556px 0 0 -5px #cfcfcf, 557px 0 0 -5px #cfcfcf, 558px 0 0 -5px #cfcfcf, 559px 0 0 -5px #cfcfcf, 560px 0 0 -5px #cfcfcf, 561px 0 0 -5px #cfcfcf, 562px 0 0 -5px #cfcfcf, 563px 0 0 -5px #cfcfcf, 564px 0 0 -5px #cfcfcf, 565px 0 0 -5px #cfcfcf, 566px 0 0 -5px #cfcfcf, 567px 0 0 -5px #cfcfcf, 568px 0 0 -5px #cfcfcf, 569px 0 0 -5px #cfcfcf, 570px 0 0 -5px #cfcfcf, 571px 0 0 -5px #cfcfcf, 572px 0 0 -5px #cfcfcf, 573px 0 0 -5px #cfcfcf, 574px 0 0 -5px #cfcfcf, 575px 0 0 -5px #cfcfcf, 576px 0 0 -5px #cfcfcf, 577px 0 0 -5px #cfcfcf, 578px 0 0 -5px #cfcfcf, 579px 0 0 -5px #cfcfcf, 580px 0 0 -5px #cfcfcf, 581px 0 0 -5px #cfcfcf, 582px 0 0 -5px #cfcfcf, 583px 0 0 -5px #cfcfcf, 584px 0 0 -5px #cfcfcf, 585px 0 0 -5px #cfcfcf, 586px 0 0 -5px #cfcfcf, 587px 0 0 -5px #cfcfcf, 588px 0 0 -5px #cfcfcf, 589px 0 0 -5px #cfcfcf, 590px 0 0 -5px #cfcfcf, 591px 0 0 -5px #cfcfcf, 592px 0 0 -5px #cfcfcf, 593px 0 0 -5px #cfcfcf, 594px 0 0 -5px #cfcfcf, 595px 0 0 -5px #cfcfcf, 596px 0 0 -5px #cfcfcf, 597px 0 0 -5px #cfcfcf, 598px 0 0 -5px #cfcfcf, 599px 0 0 -5px #cfcfcf, 600px 0 0 -5px #cfcfcf, 601px 0 0 -5px #cfcfcf, 602px 0 0 -5px #cfcfcf, 603px 0 0 -5px #cfcfcf, 604px 0 0 -5px #cfcfcf, 605px 0 0 -5px #cfcfcf, 606px 0 0 -5px #cfcfcf, 607px 0 0 -5px #cfcfcf, 608px 0 0 -5px #cfcfcf, 609px 0 0 -5px #cfcfcf, 610px 0 0 -5px #cfcfcf, 611px 0 0 -5px #cfcfcf, 612px 0 0 -5px #cfcfcf, 613px 0 0 -5px #cfcfcf, 614px 0 0 -5px #cfcfcf, 615px 0 0 -5px #cfcfcf, 616px 0 0 -5px #cfcfcf, 617px 0 0 -5px #cfcfcf, 618px 0 0 -5px #cfcfcf, 619px 0 0 -5px #cfcfcf, 620px 0 0 -5px #cfcfcf, 621px 0 0 -5px #cfcfcf, 622px 0 0 -5px #cfcfcf, 623px 0 0 -5px #cfcfcf, 624px 0 0 -5px #cfcfcf, 625px 0 0 -5px #cfcfcf, 626px 0 0 -5px #cfcfcf, 627px 0 0 -5px #cfcfcf, 628px 0 0 -5px #cfcfcf, 629px 0 0 -5px #cfcfcf, 630px 0 0 -5px #cfcfcf, 631px 0 0 -5px #cfcfcf, 632px 0 0 -5px #cfcfcf, 633px 0 0 -5px #cfcfcf, 634px 0 0 -5px #cfcfcf, 635px 0 0 -5px #cfcfcf, 636px 0 0 -5px #cfcfcf, 637px 0 0 -5px #cfcfcf, 638px 0 0 -5px #cfcfcf, 639px 0 0 -5px #cfcfcf, 640px 0 0 -5px #cfcfcf, 641px 0 0 -5px #cfcfcf, 642px 0 0 -5px #cfcfcf, 643px 0 0 -5px #cfcfcf, 644px 0 0 -5px #cfcfcf, 645px 0 0 -5px #cfcfcf, 646px 0 0 -5px #cfcfcf, 647px 0 0 -5px #cfcfcf, 648px 0 0 -5px #cfcfcf, 649px 0 0 -5px #cfcfcf, 650px 0 0 -5px #cfcfcf, 651px 0 0 -5px #cfcfcf, 652px 0 0 -5px #cfcfcf, 653px 0 0 -5px #cfcfcf, 654px 0 0 -5px #cfcfcf, 655px 0 0 -5px #cfcfcf, 656px 0 0 -5px #cfcfcf, 657px 0 0 -5px #cfcfcf, 658px 0 0 -5px #cfcfcf, 659px 0 0 -5px #cfcfcf, 660px 0 0 -5px #cfcfcf, 661px 0 0 -5px #cfcfcf, 662px 0 0 -5px #cfcfcf, 663px 0 0 -5px #cfcfcf, 664px 0 0 -5px #cfcfcf, 665px 0 0 -5px #cfcfcf, 666px 0 0 -5px #cfcfcf, 667px 0 0 -5px #cfcfcf, 668px 0 0 -5px #cfcfcf, 669px 0 0 -5px #cfcfcf, 670px 0 0 -5px #cfcfcf, 671px 0 0 -5px #cfcfcf, 672px 0 0 -5px #cfcfcf, 673px 0 0 -5px #cfcfcf, 674px 0 0 -5px #cfcfcf, 675px 0 0 -5px #cfcfcf, 676px 0 0 -5px #cfcfcf, 677px 0 0 -5px #cfcfcf, 678px 0 0 -5px #cfcfcf, 679px 0 0 -5px #cfcfcf, 680px 0 0 -5px #cfcfcf, 681px 0 0 -5px #cfcfcf, 682px 0 0 -5px #cfcfcf, 683px 0 0 -5px #cfcfcf, 684px 0 0 -5px #cfcfcf, 685px 0 0 -5px #cfcfcf, 686px 0 0 -5px #cfcfcf, 687px 0 0 -5px #cfcfcf, 688px 0 0 -5px #cfcfcf, 689px 0 0 -5px #cfcfcf, 690px 0 0 -5px #cfcfcf, 691px 0 0 -5px #cfcfcf, 692px 0 0 -5px #cfcfcf, 693px 0 0 -5px #cfcfcf, 694px 0 0 -5px #cfcfcf, 695px 0 0 -5px #cfcfcf, 696px 0 0 -5px #cfcfcf, 697px 0 0 -5px #cfcfcf, 698px 0 0 -5px #cfcfcf, 699px 0 0 -5px #cfcfcf, 700px 0 0 -5px #cfcfcf, 701px 0 0 -5px #cfcfcf, 702px 0 0 -5px #cfcfcf, 703px 0 0 -5px #cfcfcf, 704px 0 0 -5px #cfcfcf, 705px 0 0 -5px #cfcfcf, 706px 0 0 -5px #cfcfcf, 707px 0 0 -5px #cfcfcf, 708px 0 0 -5px #cfcfcf, 709px 0 0 -5px #cfcfcf, 710px 0 0 -5px #cfcfcf, 711px 0 0 -5px #cfcfcf, 712px 0 0 -5px #cfcfcf, 713px 0 0 -5px #cfcfcf, 714px 0 0 -5px #cfcfcf, 715px 0 0 -5px #cfcfcf, 716px 0 0 -5px #cfcfcf, 717px 0 0 -5px #cfcfcf, 718px 0 0 -5px #cfcfcf, 719px 0 0 -5px #cfcfcf, 720px 0 0 -5px #cfcfcf, 721px 0 0 -5px #cfcfcf, 722px 0 0 -5px #cfcfcf, 723px 0 0 -5px #cfcfcf, 724px 0 0 -5px #cfcfcf, 725px 0 0 -5px #cfcfcf, 726px 0 0 -5px #cfcfcf, 727px 0 0 -5px #cfcfcf, 728px 0 0 -5px #cfcfcf, 729px 0 0 -5px #cfcfcf, 730px 0 0 -5px #cfcfcf, 731px 0 0 -5px #cfcfcf, 732px 0 0 -5px #cfcfcf, 733px 0 0 -5px #cfcfcf, 734px 0 0 -5px #cfcfcf, 735px 0 0 -5px #cfcfcf, 736px 0 0 -5px #cfcfcf, 737px 0 0 -5px #cfcfcf, 738px 0 0 -5px #cfcfcf, 739px 0 0 -5px #cfcfcf, 740px 0 0 -5px #cfcfcf, 741px 0 0 -5px #cfcfcf, 742px 0 0 -5px #cfcfcf, 743px 0 0 -5px #cfcfcf, 744px 0 0 -5px #cfcfcf, 745px 0 0 -5px #cfcfcf, 746px 0 0 -5px #cfcfcf, 747px 0 0 -5px #cfcfcf, 748px 0 0 -5px #cfcfcf, 749px 0 0 -5px #cfcfcf, 750px 0 0 -5px #cfcfcf, 751px 0 0 -5px #cfcfcf, 752px 0 0 -5px #cfcfcf, 753px 0 0 -5px #cfcfcf, 754px 0 0 -5px #cfcfcf, 755px 0 0 -5px #cfcfcf, 756px 0 0 -5px #cfcfcf, 757px 0 0 -5px #cfcfcf, 758px 0 0 -5px #cfcfcf, 759px 0 0 -5px #cfcfcf, 760px 0 0 -5px #cfcfcf, 761px 0 0 -5px #cfcfcf, 762px 0 0 -5px #cfcfcf, 763px 0 0 -5px #cfcfcf, 764px 0 0 -5px #cfcfcf, 765px 0 0 -5px #cfcfcf, 766px 0 0 -5px #cfcfcf, 767px 0 0 -5px #cfcfcf, 768px 0 0 -5px #cfcfcf, 769px 0 0 -5px #cfcfcf, 770px 0 0 -5px #cfcfcf, 771px 0 0 -5px #cfcfcf, 772px 0 0 -5px #cfcfcf, 773px 0 0 -5px #cfcfcf, 774px 0 0 -5px #cfcfcf, 775px 0 0 -5px #cfcfcf, 776px 0 0 -5px #cfcfcf, 777px 0 0 -5px #cfcfcf, 778px 0 0 -5px #cfcfcf, 779px 0 0 -5px #cfcfcf, 780px 0 0 -5px #cfcfcf, 781px 0 0 -5px #cfcfcf, 782px 0 0 -5px #cfcfcf, 783px 0 0 -5px #cfcfcf, 784px 0 0 -5px #cfcfcf, 785px 0 0 -5px #cfcfcf, 786px 0 0 -5px #cfcfcf, 787px 0 0 -5px #cfcfcf, 788px 0 0 -5px #cfcfcf, 789px 0 0 -5px #cfcfcf, 790px 0 0 -5px #cfcfcf, 791px 0 0 -5px #cfcfcf, 792px 0 0 -5px #cfcfcf, 793px 0 0 -5px #cfcfcf, 794px 0 0 -5px #cfcfcf, 795px 0 0 -5px #cfcfcf, 796px 0 0 -5px #cfcfcf, 797px 0 0 -5px #cfcfcf, 798px 0 0 -5px #cfcfcf, 799px 0 0 -5px #cfcfcf, 800px 0 0 -5px #cfcfcf, 801px 0 0 -5px #cfcfcf, 802px 0 0 -5px #cfcfcf, 803px 0 0 -5px #cfcfcf, 804px 0 0 -5px #cfcfcf, 805px 0 0 -5px #cfcfcf, 806px 0 0 -5px #cfcfcf, 807px 0 0 -5px #cfcfcf, 808px 0 0 -5px #cfcfcf, 809px 0 0 -5px #cfcfcf, 810px 0 0 -5px #cfcfcf, 811px 0 0 -5px #cfcfcf, 812px 0 0 -5px #cfcfcf, 813px 0 0 -5px #cfcfcf, 814px 0 0 -5px #cfcfcf, 815px 0 0 -5px #cfcfcf, 816px 0 0 -5px #cfcfcf, 817px 0 0 -5px #cfcfcf, 818px 0 0 -5px #cfcfcf, 819px 0 0 -5px #cfcfcf, 820px 0 0 -5px #cfcfcf, 821px 0 0 -5px #cfcfcf, 822px 0 0 -5px #cfcfcf, 823px 0 0 -5px #cfcfcf, 824px 0 0 -5px #cfcfcf, 825px 0 0 -5px #cfcfcf, 826px 0 0 -5px #cfcfcf, 827px 0 0 -5px #cfcfcf, 828px 0 0 -5px #cfcfcf, 829px 0 0 -5px #cfcfcf, 830px 0 0 -5px #cfcfcf, 831px 0 0 -5px #cfcfcf, 832px 0 0 -5px #cfcfcf, 833px 0 0 -5px #cfcfcf, 834px 0 0 -5px #cfcfcf, 835px 0 0 -5px #cfcfcf, 836px 0 0 -5px #cfcfcf, 837px 0 0 -5px #cfcfcf, 838px 0 0 -5px #cfcfcf, 839px 0 0 -5px #cfcfcf, 840px 0 0 -5px #cfcfcf, 841px 0 0 -5px #cfcfcf, 842px 0 0 -5px #cfcfcf, 843px 0 0 -5px #cfcfcf, 844px 0 0 -5px #cfcfcf, 845px 0 0 -5px #cfcfcf, 846px 0 0 -5px #cfcfcf, 847px 0 0 -5px #cfcfcf, 848px 0 0 -5px #cfcfcf, 849px 0 0 -5px #cfcfcf, 850px 0 0 -5px #cfcfcf, 851px 0 0 -5px #cfcfcf, 852px 0 0 -5px #cfcfcf, 853px 0 0 -5px #cfcfcf, 854px 0 0 -5px #cfcfcf, 855px 0 0 -5px #cfcfcf, 856px 0 0 -5px #cfcfcf, 857px 0 0 -5px #cfcfcf, 858px 0 0 -5px #cfcfcf, 859px 0 0 -5px #cfcfcf, 860px 0 0 -5px #cfcfcf, 861px 0 0 -5px #cfcfcf, 862px 0 0 -5px #cfcfcf, 863px 0 0 -5px #cfcfcf, 864px 0 0 -5px #cfcfcf, 865px 0 0 -5px #cfcfcf, 866px 0 0 -5px #cfcfcf, 867px 0 0 -5px #cfcfcf, 868px 0 0 -5px #cfcfcf, 869px 0 0 -5px #cfcfcf, 870px 0 0 -5px #cfcfcf, 871px 0 0 -5px #cfcfcf, 872px 0 0 -5px #cfcfcf, 873px 0 0 -5px #cfcfcf, 874px 0 0 -5px #cfcfcf, 875px 0 0 -5px #cfcfcf, 876px 0 0 -5px #cfcfcf, 877px 0 0 -5px #cfcfcf, 878px 0 0 -5px #cfcfcf, 879px 0 0 -5px #cfcfcf, 880px 0 0 -5px #cfcfcf, 881px 0 0 -5px #cfcfcf, 882px 0 0 -5px #cfcfcf, 883px 0 0 -5px #cfcfcf, 884px 0 0 -5px #cfcfcf, 885px 0 0 -5px #cfcfcf, 886px 0 0 -5px #cfcfcf, 887px 0 0 -5px #cfcfcf, 888px 0 0 -5px #cfcfcf, 889px 0 0 -5px #cfcfcf, 890px 0 0 -5px #cfcfcf, 891px 0 0 -5px #cfcfcf, 892px 0 0 -5px #cfcfcf, 893px 0 0 -5px #cfcfcf, 894px 0 0 -5px #cfcfcf, 895px 0 0 -5px #cfcfcf, 896px 0 0 -5px #cfcfcf, 897px 0 0 -5px #cfcfcf, 898px 0 0 -5px #cfcfcf, 899px 0 0 -5px #cfcfcf, 900px 0 0 -5px #cfcfcf, 901px 0 0 -5px #cfcfcf, 902px 0 0 -5px #cfcfcf, 903px 0 0 -5px #cfcfcf, 904px 0 0 -5px #cfcfcf, 905px 0 0 -5px #cfcfcf, 906px 0 0 -5px #cfcfcf, 907px 0 0 -5px #cfcfcf, 908px 0 0 -5px #cfcfcf, 909px 0 0 -5px #cfcfcf, 910px 0 0 -5px #cfcfcf, 911px 0 0 -5px #cfcfcf, 912px 0 0 -5px #cfcfcf, 913px 0 0 -5px #cfcfcf, 914px 0 0 -5px #cfcfcf, 915px 0 0 -5px #cfcfcf, 916px 0 0 -5px #cfcfcf, 917px 0 0 -5px #cfcfcf, 918px 0 0 -5px #cfcfcf, 919px 0 0 -5px #cfcfcf, 920px 0 0 -5px #cfcfcf, 921px 0 0 -5px #cfcfcf, 922px 0 0 -5px #cfcfcf, 923px 0 0 -5px #cfcfcf, 924px 0 0 -5px #cfcfcf, 925px 0 0 -5px #cfcfcf, 926px 0 0 -5px #cfcfcf, 927px 0 0 -5px #cfcfcf, 928px 0 0 -5px #cfcfcf, 929px 0 0 -5px #cfcfcf, 930px 0 0 -5px #cfcfcf, 931px 0 0 -5px #cfcfcf, 932px 0 0 -5px #cfcfcf, 933px 0 0 -5px #cfcfcf, 934px 0 0 -5px #cfcfcf, 935px 0 0 -5px #cfcfcf, 936px 0 0 -5px #cfcfcf, 937px 0 0 -5px #cfcfcf, 938px 0 0 -5px #cfcfcf, 939px 0 0 -5px #cfcfcf, 940px 0 0 -5px #cfcfcf, 941px 0 0 -5px #cfcfcf, 942px 0 0 -5px #cfcfcf, 943px 0 0 -5px #cfcfcf, 944px 0 0 -5px #cfcfcf, 945px 0 0 -5px #cfcfcf, 946px 0 0 -5px #cfcfcf, 947px 0 0 -5px #cfcfcf, 948px 0 0 -5px #cfcfcf, 949px 0 0 -5px #cfcfcf, 950px 0 0 -5px #cfcfcf, 951px 0 0 -5px #cfcfcf, 952px 0 0 -5px #cfcfcf, 953px 0 0 -5px #cfcfcf, 954px 0 0 -5px #cfcfcf, 955px 0 0 -5px #cfcfcf, 956px 0 0 -5px #cfcfcf, 957px 0 0 -5px #cfcfcf, 958px 0 0 -5px #cfcfcf, 959px 0 0 -5px #cfcfcf, 960px 0 0 -5px #cfcfcf, 961px 0 0 -5px #cfcfcf, 962px 0 0 -5px #cfcfcf, 963px 0 0 -5px #cfcfcf, 964px 0 0 -5px #cfcfcf, 965px 0 0 -5px #cfcfcf, 966px 0 0 -5px #cfcfcf, 967px 0 0 -5px #cfcfcf, 968px 0 0 -5px #cfcfcf, 969px 0 0 -5px #cfcfcf, 970px 0 0 -5px #cfcfcf, 971px 0 0 -5px #cfcfcf, 972px 0 0 -5px #cfcfcf, 973px 0 0 -5px #cfcfcf, 974px 0 0 -5px #cfcfcf, 975px 0 0 -5px #cfcfcf, 976px 0 0 -5px #cfcfcf, 977px 0 0 -5px #cfcfcf, 978px 0 0 -5px #cfcfcf, 979px 0 0 -5px #cfcfcf, 980px 0 0 -5px #cfcfcf, 981px 0 0 -5px #cfcfcf, 982px 0 0 -5px #cfcfcf, 983px 0 0 -5px #cfcfcf, 984px 0 0 -5px #cfcfcf, 985px 0 0 -5px #cfcfcf, 986px 0 0 -5px #cfcfcf, 987px 0 0 -5px #cfcfcf, 988px 0 0 -5px #cfcfcf, 989px 0 0 -5px #cfcfcf, 990px 0 0 -5px #cfcfcf, 991px 0 0 -5px #cfcfcf, 992px 0 0 -5px #cfcfcf, 993px 0 0 -5px #cfcfcf, 994px 0 0 -5px #cfcfcf, 995px 0 0 -5px #cfcfcf, 996px 0 0 -5px #cfcfcf, 997px 0 0 -5px #cfcfcf, 998px 0 0 -5px #cfcfcf, 999px 0 0 -5px #cfcfcf, 1000px 0 0 -5px #cfcfcf;
    transition: background-color .15s;
  }

  .hubspot-styles .hs-input-range__slider::-moz-range-progress,
  .hubspot-styles .hs-input-range__slider::-moz-range-track {
    width: 100%;
    height: 30px;
    background: linear-gradient(180deg, #cfcfcf, #cfcfcf) 100% 50%/100% 3px no-repeat transparent;
  }

  .hubspot-styles .hs-input-range__slider::-moz-range-progress {
    background: linear-gradient(180deg, #0199ff, #0199ff) 100% 50%/100% 3px no-repeat transparent;
  }

  .hubspot-styles .hs-input-range__slider::-moz-range-thumb {
    appearance: none;
    margin: 0;
    height: 13px;
    width: 13px;
    background: #0199ff;
    border-radius: 100%;
    border: 0;
    transition: background-color .15s;
  }

  .hubspot-styles .hs-input-range__slider::-ms-track {
    width: 100%;
    height: 30px;
    border: 0;
    color: transparent;
    background: transparent;
  }

  .hubspot-styles .hs-input-range__slider::-ms-fill-lower {
    background: linear-gradient(180deg, #0199ff, #0199ff) 100% 50%/100% 3px no-repeat transparent;
  }

  .hubspot-styles .hs-input-range__slider::-ms-fill-upper {
    background: linear-gradient(180deg, #cfcfcf, #cfcfcf) 100% 50%/100% 3px no-repeat transparent;
  }

  .hubspot-styles .hs-input-range__slider::-ms-thumb {
    appearance: none;
    height: 13px;
    width: 13px;
    background: #0199ff;
    border-radius: 100%;
    border: 0;
    transition: background-color .15s;
    top: 0;
    margin: 0;
    box-shadow: none;
  }

  .hubspot-styles .hs-input-range__slider:focus::-webkit-slider-thumb,
  .hubspot-styles .hs-input-range__slider:hover::-webkit-slider-thumb {
    background-color: #55c2ff;
  }

  .hubspot-styles .hs-input-range__slider:focus::-moz-range-thumb,
  .hubspot-styles .hs-input-range__slider:hover::-moz-range-thumb {
    background-color: #55c2ff;
  }

  .hubspot-styles .hs-input-range__slider:focus::-ms-thumb,
  .hubspot-styles .hs-input-range__slider:hover::-ms-thumb {
    background-color: #55c2ff;
  }

  .hubspot-styles .hs-input-rating__container {
    width: 100%;
    margin-bottom: 30px;
    display: table;
    table-layout: fixed;
  }

  .hubspot-styles .hs-input-rating__container section {
    display: table-row;
  }

  .hubspot-styles .hs-input-rating__label {
    position: relative;
    display: table-cell;
    vertical-align: middle;
    text-align: center;
  }

  .hubspot-styles .hs-input-rating__label input,
  .hubspot-styles .hs-input-rating__label svg {
    position: absolute;
    top: 20px;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    display: block;
    cursor: pointer;
  }

  .hubspot-styles .hs-input-rating__label svg {
    position: absolute;
    width: 45px;
    height: 45px;
    fill: #fff;
    stroke: #ccc;
    transform: scale(0.6);
    transition: transform .2s ease-in-out;
  }

  .hubspot-styles .hs-input-rating__label path {
    transition: fill .2s ease-in-out, stroke .1s ease-in-out;
  }

  .hubspot-styles .hs-input-rating__is-star input {
    display: none;
  }

  .hubspot-styles .hs-input-rating__svg-is-selected {
    transform: scale(0.7);
  }

  .hubspot-styles .hs-input-rating__svg-is-selected path {
    fill: #f7e31b;
    stroke: #d7c508;
  }

  .hubspot-styles.hbspt-form .hs-button {
    white-space: pre-wrap;
  }

  .hubspot-styles.hbspt-form .hs-richtext {
    word-break: break-word;
  }

  .hubspot-styles.hbspt-form.submitted-message {
    overflow: auto;
  }

  .hbspt-contain {
    display: flex;
    justify-content: center;
  }

  p + .hbspt-contain {
    margin-top: 25px;
  }

  .hubspot-styles.hbspt-form fieldset {
    border: 0;
    padding: 0;
    margin: 0;
    max-width: initial;
  }

  .hubspot-styles.hbspt-form fieldset.form-columns-0 .hs-richtext strong {
    font-size: 14pt;
  }

  .hubspot-styles.hbspt-form fieldset.form-columns-0 {
    margin-bottom: 10px;
  }

  .hubspot-styles.hbspt-form fieldset.form-columns-1 .hs-input {
    width: 100%;
  }

  .hubspot-styles.hbspt-form fieldset.form-columns-1 .input {
    margin-right: 0;
  }

  .hubspot-styles.hbspt-form fieldset.form-columns-1 input[type=checkbox],
  .hubspot-styles.hbspt-form fieldset.form-columns-1 input[type=radio] {
    width: auto;
  }

  .hubspot-styles.hbspt-form fieldset.form-columns-2 .hs-form-field {
    width: 50%;
    float: left;
  }

  .hubspot-styles.hbspt-form fieldset.form-columns-2 .input {
    margin-right: 0;
  }

  .hubspot-styles.hbspt-form fieldset.form-columns-2 .hs-form-field {
    padding-left: 5px;
    padding-right: 0;
  }
  .hubspot-styles.hbspt-form fieldset.form-columns-2 .hs-form-field {
    &:first-child ${ignoreSsrFlag} {
      padding-left: 0;
      padding-right: 5px;
    }
  }

  .hubspot-styles.hbspt-form fieldset.form-columns-3 .hs-form-field {
    width: 32.7%;
    float: left;
  }

  .hubspot-styles.hbspt-form fieldset.form-columns-3 .input {
    margin-right: 8px;
  }

  .hubspot-styles.hbspt-form label.hs-hidden {
    visibility: hidden;
  }

  .hubspot-styles.hbspt-form .hs-field-desc {
    width: 100%;
  }

  .hubspot-styles .hs-custom-style .hs-input,
  .hubspot-styles .hs-custom-style fieldset {
    max-width: 100%;
  }

  .hubspot-styles .hs-custom-style > div.form-columns-3 .hs-form-field,
  .hubspot-styles .hs-custom-style fieldset.form-columns-3 .hs-form-field {
    width: 33.3%;
  }

  .hubspot-styles .hs-custom-style > div > div:last-of-type .hs-input:not([type=checkbox]):not([type=radio]),
  .hubspot-styles .hs-custom-style fieldset > div:last-of-type .hs-input:not([type=checkbox]):not([type=radio]) {
    width: 100%;
    max-width: 100%;
  }

  .hubspot-styles .hs-custom-style > div input:not([type=image]):not([type=submit]):not([type=button]):not([type=radio]):not([type=checkbox]):not([type=file]),
  .hubspot-styles .hs-custom-style fieldset input:not([type=image]):not([type=submit]):not([type=button]):not([type=radio]):not([type=checkbox]):not([type=file]) {
    box-sizing: border-box;
    padding: 0 15px;
    min-height: 27px;
  }

  .hubspot-styles .hs-custom-style > div textarea,
  .hubspot-styles .hs-custom-style fieldset textarea {
    padding: 10px 15px;
  }

  .hubspot-styles .hs-custom-style .hs-dependent-field > div .hs-input:not([type=checkbox]):not([type=radio]) {
    width: 100%;
  }

  @media (max-width: 400px), (min-device-width: 320px) and (max-device-width: 480px) {
    .hubspot-styles .hs-custom-style .hs-input:not([type=checkbox]):not([type=radio]),
    .hubspot-styles .hs-custom-style fieldset {
      margin-right: 0 !important;
      width: 100% !important;
    }

    .hubspot-styles form.hbspt-form:not(.hs-video-form) .form-columns-2 .hs-form-field,
    .hubspot-styles form.hbspt-form:not(.hs-video-form) .form-columns-3 .hs-form-field {
      float: none;
      width: 100%;
    }

    .hubspot-styles form.hbspt-form:not(.hs-video-form) .form-columns-2 .hs-form-field .hs-input,
    .hubspot-styles form.hbspt-form:not(.hs-video-form) .form-columns-3 .hs-form-field .hs-input {
      width: 100%;
    }

    .hubspot-styles form.hbspt-form:not(.hs-video-form) .form-columns-2 .hs-form-field input[type=checkbox],
    .hubspot-styles form.hbspt-form:not(.hs-video-form) .form-columns-2 .hs-form-field input[type=radio],
    .hubspot-styles form.hbspt-form:not(.hs-video-form) .form-columns-3 .hs-form-field input[type=checkbox],
    .hubspot-styles form.hbspt-form:not(.hs-video-form) .form-columns-3 .hs-form-field input[type=radio] {
      width: auto;
    }

    .hubspot-styles.hbspt-form fieldset.form-columns-2 .hs-form-field {
      padding-left: 0;
      padding-right: 0;
    }
    .hubspot-styles.hbspt-form fieldset.form-columns-2 .hs-form-field {
      &:first-child ${ignoreSsrFlag} {
        padding-right: 0;
      }
    }
  }

  .hubspot-styles .legal-consent-container .field.hs-form-field {
    margin-bottom: 8px;
  }

  .hubspot-styles .legal-consent-container .hs-field-desc.checkbox-desc {
    margin: -12px 0 0 21px;
  }

  .hubspot-styles .legal-consent-container .hs-form-booleancheckbox-display input {
    float: left;
  }

  .hubspot-styles .legal-consent-container .hs-form-booleancheckbox-display > span {
    display: block;
    margin-left: 20px;
  }

  .hubspot-styles .legal-consent-container .hs-form-booleancheckbox-display p {
    margin: 0;
    display: inline;
  }

  .hubspot-styles .legal-consent-container .hs-error-msgs label {
    color: #e90000;
  }

  .hubspot-styles .legal-consent-container ~ .hs_recaptcha {
    margin-top: 18px;
  }

  .hubspot-styles .cookie-reset-container {
    font-size: 14px;
    margin-bottom: 10px;
    text-align: right;
  }

  .hubspot-styles #hs-outer-captcha-target,
  .hubspot-styles #hs-outer-captcha-target * {
    display: none;
    height: 0;
    width: 0;
  }

  .hubspot-styles .hubspot-link__container {
    font-size: 14px;
    padding-bottom: 40px;
    position: relative;
    color: #9fa0a2;
  }

  .hubspot-styles .hubspot-link-text {
    color: #00a4bd;
    font-weight: 400;
  }

  .hubspot-styles .hubspot-link__container.sproket {
    color: #9fa0a2;
  }

  .hubspot-styles .hubspot-link {
    color: #9fa0a2;
  }

  .hubspot-styles .hubspot-link,
  .hubspot-styles .hubspot-link:hover {
    text-decoration: none;
  }

  .hubspot-styles .hubspot-link:hover .hubspot-link-text {
    text-decoration: underline;
  }

  .hubspot-styles .hubspot-link__icon {
    margin-bottom: -1px;
    margin-right: 5px;
  }

  .hubspot-styles .hubspot-link__container.sproket .hubspot-link__icon {
    width: 30px;
    margin-right: 0;
    float: left;
    margin-top: -9px;
    margin-left: -5px;
  }

  .hubspot-styles.hbspt-form legend + * {
    margin-top: 0;
  }

  /*************** Hubspot Center ***************/
  .hubspot-center .hubspot-styles.hbspt-form .hs-submit > .actions {
    text-align: center;
  }

  .hubspot-center .hubspot-styles.hbspt-form .legal-consent-container .hs-richtext {
    line-height: 20px;
  }

  .hubspot-center .hs-email {
    margin-top: 32px;
  }

  .hubspot-center .legal-consent-container {
    margin-bottom: 36px;
  }

  .form-center + .hubspot-styles.hbspt-form fieldset {
    margin: auto
  }
  .form-center + .hubspot-styles.hbspt-form .hs-submit > .actions {
    text-align: center;
  }
  .early-start-program  + .hubspot-styles.hbspt-form form {
    max-width: initial;
    margin: auto
  }
`;
